export function UrlBindController() {
  const vm = this

  vm.args = $.fn.urlparams()
}
